export const BaseCustomerOfferRejectionCauses = [
  { label: 'price.singular', id: 'price' },
  { label: 'candidates.experience', id: 'experience' },
  { label: 'qualifications.singular', id: 'qualification' },
  { label: 'candidates.negativeExperience', id: 'negativeExperience' },
  { label: 'work.miscellaneous', id: 'other' },
];
